var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNolejLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1525.83 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #071424;\n      }\n\n      .cls-3 {\n        fill: #00cb63;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -7.63,
    y: -5.4,
    width: 1541.09,
    height: 1090.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M486.51,478.18v151.93h-59.08v-146.97c0-31.78-23.34-53.62-53.13-53.62s-53.13,23.34-53.13,55.11v145.48h-59.09v-255.7h57.59v34.26c14.9-23.34,42.7-37.74,72.49-37.74,57.1,0,94.34,36.74,94.34,107.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M521.34,502.02c0-72.49,55.61-131.08,126.12-131.08h.5c70.51,0,125.12,59.09,125.12,131.08s-54.62,131.08-125.12,131.08h-.5c-70.51,0-126.12-58.59-126.12-131.08ZM647.95,574.51c37.74,0,66.04-32.77,66.04-72.49s-28.3-72.49-66.04-72.49h-.5c-38.23,0-66.53,32.77-66.53,72.49s28.3,72.49,66.53,72.49h.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M871.73,630.12h-59.09v-357.49h59.09v357.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1038.91,580.47c30.29,0,47.17-18.87,52.14-33.27h60.08c-3.48,23.34-31.78,85.9-112.21,85.9-73.98,0-127.6-56.11-127.6-131.08s54.62-131.08,125.12-131.08,119.16,58.59,119.16,129.59c0,6.45-.5,13.4-.99,18.37h-181.72c4.47,34.26,25.32,61.57,66.04,61.57ZM974.86,477.69h120.65c-5.46-30.78-25.32-54.12-59.09-54.12s-55.61,22.84-61.57,54.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1253.32,374.41v275.07c0,45.18-37.24,82.42-82.92,82.42h-31.28v-54.62h27.8c15.89,0,28.3-12.41,28.3-28.3v-274.57h58.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1181.82,303.3c0-22.84,18.37-41.21,40.72-41.21s41.21,18.37,41.21,41.21-18.87,40.72-41.21,40.72-40.72-17.88-40.72-40.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M842.19,818.18c-86.74,0-163.18-52.23-194.75-133.05l51.39-20.07c23.24,59.51,79.51,97.96,143.36,97.96s120.12-38.45,143.36-97.96l51.39,20.07c-31.57,80.83-108.01,133.05-194.75,133.05Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNolejLogo);
export default __webpack_public_path__ + "static/media/nolej-logo.b4f3ca8be7ed2d33265e2cdbc90a6068.svg";
export { ForwardRef as ReactComponent };